import Accessories from "../../Canva/Accessories";
import Canva from "../../Canva/Canva";
import Konva from "../../Canva/Konva";
import Point from "../../Canva/Point";
import Polygon from "../../Canva/Polygon";

function onPressShift(e) {
  if (e.code === "ShiftLeft" || e.code === "ShiftRight") {
    Canva.shiftPressed = true;
  } else {
    Canva.shiftPressed = false;
  }
}

function onUnpressShift(e) {
  if (e.code === "ShiftLeft" || e.code === "ShiftRight") {
    Canva.shiftPressed = false;
  }
}

function getHeatArea(store, Polygon) {
  const room_area = store.polygon
    ? Polygon.getAreaByShoelaceFormula(store.polygon.points)
    : 0;
  var sum_spot_area = 0;
  store.spots.forEach((itm) => {
    const area = Polygon.getAreaByShoelaceFormula(itm.points);
    sum_spot_area += area;
  });

  return Number(parseFloat(room_area - sum_spot_area).toFixed(2));
}

const addThermoFunc = function (canva, polygon, id) {
  if (polygon) {
    canva.stage.find(".poly_outline").forEach((elm) => {
      if (elm.getAttr("parent_obj") === polygon) {
        elm.destroy();
      }
    });

    const poly = new canva.Konva.Line({
      points: [
        ...polygon.getPointsCoords(),
        polygon.getPointsCoords()[0],
        polygon.getPointsCoords()[1],
      ],
      stroke: "transparent",
      opacity: 0.5,
      strokeWidth: 18,
      name: "poly_outline",
      parent_obj: polygon,
      x: polygon.x,
      y: polygon.y,
    });

    canva.layer1.add(poly);

    const badgeBack = new canva.Konva.Circle({
      x: 0,
      y: 0,
      radius: 17,
      fill: "rgba(38, 39, 41, 0.72)",
      stroke: "rgba(255, 255, 255, 0.42)",
      strokeWidth: 1,
    });
    const badgeFace = new canva.Konva.Circle({
      x: 0,
      y: 0,
      radius: 14.5,
      fill: "#242527",
      stroke: "white",
      strokeWidth: 1.5,
    });
    var groupOut = new canva.Konva.Group({
      x: polygon.points[0].x + polygon.x,
      y: polygon.points[0].y + polygon.y,
      draggable: true,
      name: "thermo",
      id: id,
      dragBoundFunc: function (pos) {
        var intersects = canva.stage.getAllIntersections({
          x: pos.x,
          y: pos.y,
        });
        intersects = intersects.filter((item) => {
          return item.getName() === "poly_outline" || item.getName() === "poly";
        });
        if (intersects.length > 1) {
          return pos;
        }
        var intersects1 = canva.stage.getAllIntersections({
          x: this.x(),
          y: pos.y,
        });
        intersects1 = intersects1.filter((item) => {
          return item.getName() === "poly_outline" || item.getName() === "poly";
        });
        if (intersects1.length > 1) {
          return { x: this.x(), y: pos.y };
        }

        var intersects2 = canva.stage.getAllIntersections({
          x: pos.x,
          y: this.y(),
        });
        intersects2 = intersects2.filter((item) => {
          return item.getName() === "poly_outline" || item.getName() === "poly";
        });
        if (intersects2.length > 1) {
          return { x: pos.x, y: this.y() };
        }

        return { x: this.x(), y: this.y() };
      },
    });
    const thermostatIcon = new canva.Konva.Path({
      data: "M522-560v-66.67h220V-560H522Zm0-133.33V-760h320v66.67H522ZM170.83-175.66Q116-230.65 116-308.67q0-48 23-90.16Q162-441 202.67-468v-270.67q0-42.22 29.51-71.77Q261.69-840 303.84-840q42.16 0 71.83 29.56 29.66 29.55 29.66 71.77V-468Q446-441 469-398.83q23 42.16 23 90.16 0 78.02-54.83 133.01-54.84 54.99-133.17 54.99-78.33 0-133.17-54.99Zm11.84-133.01h242.66q0-36.33-16.83-65.66-16.83-29.34-45.83-44.34l-24-14v-306q0-14.73-9.97-24.7-9.97-9.96-24.7-9.96-14.73 0-24.7 9.96-9.97 9.97-9.97 24.7v306l-24 14q-29 15-45.83 44.67t-16.83 65.33Z",
      x: -10.54,
      y: 10.56,
      scaleX: 0.022,
      scaleY: 0.022,
      fill: "white",
    });
    groupOut.add(badgeBack);
    groupOut.add(badgeFace);
    groupOut.add(thermostatIcon);

    canva.layer2.add(groupOut);
  }
  return groupOut;
};

function addSpotReady(polygon, canva, accessories) {
  const pol1 = Canva.spot(
    polygon,
    Konva,
    Canva.spotDragFunc(canva, polygon, accessories),
    1,
    polygon.x,
    polygon.y,
    canva,
    accessories
  );

  polygon.bindPoints();
  polygon.canva_obj = pol1;

  Canva.drawAll([pol1], canva.layer1);
  Canva.drawAll(
    [
      accessories.addPoints(
        polygon,
        Canva,
        Accessories.doSpotOnDrag(polygon, accessories, Polygon, canva, Point),
        canva,
        pol1
      ),
    ],
    canva.layer2
  );
  return polygon;
}

function createSpotPolygon(type, w = 100, h = 100, x = 0, y = 0) {
  var init_point_x = 0;
  var init_point_y = 0;

  var point7 = new Point(init_point_x, init_point_y);
  var point8 = new Point(init_point_x, init_point_y + Canva.scale * (h / 100));
  var point9 = new Point(
    init_point_x + Canva.scale * (w / 100),
    init_point_y + Canva.scale * (h / 100)
  );
  var point10 = new Point(init_point_x + Canva.scale * (w / 100), init_point_y);
  var polygon = new Polygon([point7, point8, point9, point10], x, y);
  if (type === 2) {
    polygon = new Polygon([point7, point8, point9], x, y);
  }
  polygon.type = type;
  polygon.width = w;
  polygon.height = h;
  return polygon;
}

function addSpot(type, w = 100, h = 100, x = 0, y = 0, canva, accessories) {
  const polygon = createSpotPolygon(type, w, h, x, y);

  const pol1 = Canva.spot(
    polygon,
    Konva,
    Canva.spotDragFunc(canva, polygon, accessories),
    1,
    x,
    y,
    canva,
    accessories
  );
  polygon.canva_obj = pol1;
  polygon.bindPoints();

  Canva.drawAll([pol1], canva.layer1);
  Canva.drawAll(
    [
      accessories.addPoints(
        polygon,
        Canva,
        Accessories.doSpotOnDrag(polygon, accessories, Polygon, canva, Point),
        canva,
        pol1
      ),
    ],
    canva.layer2
  );
  return polygon;
}

function imageLoad(e, setPDFurl, stateCanva) {
  const URL = window.webkitURL || window.URL;
  const url = URL.createObjectURL(e.target.files[0]);

  if (e.target.files[0].type === "application/pdf") {
    setPDFurl(url);
  } else {
    loadImgOnCanvas(url, stateCanva);
  }
}

function loadImgOnCanvas(url, stateCanva) {
  const img = new Image();
  img.src = url;
  img.onload = function () {
    var img_width = img.width;
    var img_height = img.height;

    var max = 200;
    var ratio = img_width > img_height ? img_width / max : img_height / max;

    var theImg = new Konva.Image({
      image: img,
      x: window.innerWidth / 2 - img_width / ratio / 2,
      y: window.innerHeight / 2 - img_height / ratio / 2,
      width: img_width / ratio,
      height: img_height / ratio,
      draggable: true,
      rotation: 0,
      name: "subimg",
    });

    stateCanva.layer1.add(theImg);
    stateCanva.layer1.draw();

    var transformer = new Konva.Transformer({
      padding: 14,
      borderStroke: "orange",
      anchorFill: "orange",
      anchorStroke: "darkorange",
      anchorCornerRadius: 10,
      name: "subImgWrap",
    });
    stateCanva.layer1.add(transformer);
    transformer.nodes([theImg]);
    transformer.zIndex(0);
    theImg.zIndex(0);
    stateCanva.layer1.batchDraw();
    document.querySelector(".modal_window").remove();
  };
}

export {
  onPressShift,
  onUnpressShift,
  getHeatArea,
  addThermoFunc,
  addSpotReady,
  addSpot,
  createSpotPolygon,
  imageLoad,
  loadImgOnCanvas,
};
